import React, { useContext, useEffect } from 'react';

import { LoaderOverlay } from '~/components/Loader';
import { useNotification } from '~/contexts/NotificationContext';
import { AuthStatus, UserAuthContext } from '~/contexts/UserAuthContext';

interface IAuthWrapper {
  children: React.ReactNode;
}

export const AuthWrapper = React.memo<IAuthWrapper>(function AuthWrapper(props) {

  const { userAuth } = useContext(UserAuthContext);

  const notify = useNotification();

  useEffect(() => {
    if (userAuth.authStatus === AuthStatus.NOT_AUTHENTICATED && !userAuth.nonce) {
      notify({type: 'error', message: 'Unable to refresh session, please refresh browser'});
    }
  }, [userAuth, notify]);

  if (!userAuth.nonce) {
    return <LoaderOverlay/>
  }

  return (
    <>
      {props.children}
    </>
  );
});
